import { render, staticRenderFns } from "./ClassPage.vue?vue&type=template&id=b6657572&scoped=true&"
import script from "./ClassPage.vue?vue&type=script&lang=js&"
export * from "./ClassPage.vue?vue&type=script&lang=js&"
import style0 from "./ClassPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClassPage.vue?vue&type=style&index=1&id=b6657572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6657572",
  null
  
)

export default component.exports